import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { DomainsService } from '../../../core/services/domains.service';
import { normalizeDomainsResponse } from '../../utils/normalizers';
import * as DomainsActions from './domains.actions';
import * as AppInitActions from '../../app-init/app-init.actions';

@Injectable()
export class DomainsEffects {
  private actions$ = inject(Actions);
  private domainsService = inject(DomainsService);

  loadDomains$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DomainsActions.loadDomains),
      switchMap(() => {
        return this.domainsService.getDomains().pipe(
          map((response) => {
            const normalized = normalizeDomainsResponse(response.data);

            return DomainsActions.loadDomainsSuccess({
              domains: normalized.entities.domains,
            });
          }),
          catchError((error: unknown) => {
            const errorMessage =
              error instanceof Error
                ? error.message
                : (error as { error?: { message?: string } })?.error?.message ||
                  (error as { message?: string })?.message ||
                  'Failed to load domains';

            return of(
              DomainsActions.loadDomainsFailure({
                error: errorMessage,
              })
            );
          })
        );
      })
    )
  );

  markDomainsInitialized$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DomainsActions.loadDomainsSuccess),
      map(() => AppInitActions.markRequestComplete({ requestKey: 'domains' }))
    )
  );

  markDomainsFailed$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DomainsActions.loadDomainsFailure),
      map(() => AppInitActions.markRequestFailed({ requestKey: 'domains' }))
    )
  );
}

